import axios from 'axios'
import store from '@/store'

export const getPDF = (url, data, documentName = 'document') => {
    store.commit('SET_LOADING', true)
    return axios.get(url, {params: data, responseType: 'blob'})
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${documentName}.pdf`) // barcodes
            document.body.appendChild(link)
            link.click()
            store.commit('SET_LOADING', false)
        })
}

export const socialConnect = social => {
    return axios.get(`${process.env.API_URL}/oauth/connect/${social}`)
        .then(response => response)
        .catch(() => {})
}



// WEBPACK FOOTER //
// ./src/api/services.js